import React, { useState } from 'react';
import { ToastsContext, Theme, seismicTheme } from '@seismic/mantle';
import { UniversalUploader } from '@seismic/universal-upload-component';
import useColors from 'ui/hooks/useColors';

const UniversalUploaderComponent = ({
  accept,
  onComplete,
  uploadMaxItems = 1,
}) => {
  const { colorPrimary } = useColors();
  const [uploads, setUploads] = useState([]);

  const handleComplete = newUploads => {
    setUploads(newUploads);
    if (typeof onComplete === 'function') {
      onComplete({
        token: newUploads[0].storageId,
        isSeismic: true,
        format: newUploads[0].file?.name?.split('.').pop(),
      });
    }
  };

  const bssUploadOptions = {
    container: 'readiness',
    owner: 'srs-lessons',
    isFullContainerName: false,
  };

  return (
    <Theme
      theme={seismicTheme({
        useGlobal: true,
        customization: {
          colors: {
            primary: colorPrimary,
          },
        },
      })}
      className="EditorElement-uploadButton d-f jc-c"
    >
      <ToastsContext>
        <UniversalUploader
          uploadMaxItems={uploadMaxItems}
          accept={accept}
          onComplete={handleComplete}
          bssUploadOptions={bssUploadOptions}
        >
          <UniversalUploader.DnD>
            <div className="mt-10 mb-24">
              <UniversalUploader.Button>
                <span className="EditorElement-uploadButton--universalVideoUploader">
                  {t('questions.question.webcam_recording.upload')}
                </span>
              </UniversalUploader.Button>
            </div>
          </UniversalUploader.DnD>
        </UniversalUploader>
      </ToastsContext>
      {uploads.length > 0 && <div className="d-f jc-c" />}
    </Theme>
  );
};

export default UniversalUploaderComponent;
